export enum UserInviteStatus {
  Invited = 0,
  Accepted = 1,
  Declined = 2,
}

export const UserInviteStatusTranslations = {
  [UserInviteStatus.Invited]: 'users.invited',
  [UserInviteStatus.Accepted]: 'users.accepted',
  [UserInviteStatus.Declined]: 'users.declined',
};
